(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'attachment';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1339px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-built-by-fans"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sg-built-by-fans]';

    const prepare = (section) => {
      if (section.dataset.sgBuiltByFansReady === 'true') return;
      section.dataset.sgBuiltByFansReady = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        section.classList.add('sg-built-by-fans--is-visible');
        return;
      }

      section.classList.add('sg-built-by-fans--motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('sg-built-by-fans--is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      observer.observe(section);
    };

    const initialize = (root = document) => {
      if (root.matches && root.matches(selector)) prepare(root);
      root.querySelectorAll(selector).forEach(prepare);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-cart-exit-intent"]) return;
  try {
    
  (function () {
    var shownKey = 'sgCartExitIntentShown';
    var dismissedKey = 'sgCartExitIntentDismissed';
    var cartQuietMs = 10000;

    function readSession(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function writeSession(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {}
    }

    function isCheckoutPage() {
      var path = window.location.pathname.toLowerCase();
      return path === '/checkout' || path.indexOf('/checkout/') === 0 || path.indexOf('/checkouts/') === 0;
    }

    function hasSessionLock() {
      return readSession(shownKey) === 'true' || readSession(dismissedKey) === 'true';
    }

    function setCartQuietPeriod(dialog) {
      if (!dialog) return;
      dialog.dataset.sgCartExitQuietUntil = String(Date.now() + cartQuietMs);
    }

    function isInQuietPeriod(dialog) {
      return Number(dialog && dialog.dataset.sgCartExitQuietUntil ? dialog.dataset.sgCartExitQuietUntil : 0) > Date.now();
    }

    function isElementVisible(element) {
      if (!element) return false;
      var style = window.getComputedStyle ? window.getComputedStyle(element) : null;

      if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) {
        return false;
      }

      return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function isCartSurfaceOpen() {
      var selectors = [
        'cart-drawer.active',
        'cart-drawer[open]',
        'cart-notification.active',
        '#CartDrawer.active',
        '#CartDrawer[open]',
        '.cart-drawer.active',
        '.cart-drawer[open]',
        '[data-cart-drawer].active',
        '[data-cart-drawer][open]'
      ];

      for (var index = 0; index < selectors.length; index += 1) {
        var element = document.querySelector(selectors[index]);
        if (isElementVisible(element)) return true;
      }

      return false;
    }

    function getCart() {
      return window.fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    function cartHasItems(cart) {
      return cart && Number(cart.item_count) > 0;
    }

    function showPopup(dialog) {
      if (!dialog || dialog.dataset.sgCartExitOpen === 'true') return false;
      if (isCheckoutPage() || hasSessionLock() || isInQuietPeriod(dialog) || isCartSurfaceOpen()) return false;

      dialog.dataset.sgCartExitOpen = 'true';
      writeSession(shownKey, 'true');

      try {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      } catch (error) {
        dialog.setAttribute('open', '');
      }

      window.requestAnimationFrame(function () {
        dialog.classList.add('is-visible');
        var cta = dialog.querySelector('[data-sg-cart-exit-cta]');
        if (cta && typeof cta.focus === 'function') {
          cta.focus({ preventScroll: true });
        }
      });

      return true;
    }

    function attemptPopup(dialog) {
      if (!dialog || isCheckoutPage() || hasSessionLock() || isInQuietPeriod(dialog) || isCartSurfaceOpen()) return Promise.resolve(false);

      return getCart().then(function (cart) {
        if (!cartHasItems(cart) || hasSessionLock() || isInQuietPeriod(dialog) || isCartSurfaceOpen()) return false;
        return showPopup(dialog);
      });
    }

    function dismissPopup(dialog) {
      if (!dialog) return;
      writeSession(dismissedKey, 'true');
      dialog.classList.remove('is-visible');
      dialog.dataset.sgCartExitOpen = 'false';

      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function setupDesktop(dialog) {
      if (dialog.dataset.sgCartExitDesktopReady === 'true') return;
      dialog.dataset.sgCartExitDesktopReady = 'true';

      var lastPointerY = window.innerHeight;

      var onPointerMove = function (event) {
        lastPointerY = event.clientY;
      };

      var removeDesktopListeners = function () {
        document.removeEventListener('mousemove', onPointerMove);
        document.documentElement.removeEventListener('mouseleave', onMouseLeave);
      };

      var onMouseLeave = function (event) {
        if (event.clientY > 0 || lastPointerY > 24) return;

        attemptPopup(dialog).then(function (didShow) {
          if (didShow) {
            removeDesktopListeners();
          }
        });
      };

      document.addEventListener('mousemove', onPointerMove, { passive: true });
      document.documentElement.addEventListener('mouseleave', onMouseLeave);
    }

    function setupMobileBackIntent(dialog) {
      if (dialog.dataset.sgCartExitBackReady === 'true') return;
      if (!window.history || typeof window.history.pushState !== 'function') return;

      dialog.dataset.sgCartExitBackReady = 'true';

      try {
        window.history.pushState({ sgCartExitIntent: true }, '', window.location.href);
      } catch (error) {
        return;
      }

      window.addEventListener('popstate', function () {
        attemptPopup(dialog).then(function (didShow) {
          if (!didShow && !dialog.open) {
            window.history.back();
          }
        });
      }, { once: true });
    }

    function setupMobile(dialog) {
      if (dialog.dataset.sgCartExitMobileReady === 'true') return;
      dialog.dataset.sgCartExitMobileReady = 'true';

      var delaySeconds = Math.max(0, Number(dialog.dataset.mobileDelay || 60));
      var scrollTarget = Math.min(100, Math.max(1, Number(dialog.dataset.mobileScroll || 75)));

      window.setTimeout(function () {
        attemptPopup(dialog);
      }, delaySeconds * 1000);

      var onScroll = function () {
        var documentElement = document.documentElement;
        var scrollableHeight = Math.max(1, documentElement.scrollHeight - window.innerHeight);
        var scrollPercent = (window.scrollY / scrollableHeight) * 100;

        if (scrollPercent >= scrollTarget) {
          window.removeEventListener('scroll', onScroll);
          attemptPopup(dialog);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });

      getCart().then(function (cart) {
        if (cartHasItems(cart) && !hasSessionLock() && !isCheckoutPage()) {
          setupMobileBackIntent(dialog);
        }
      });
    }

    function bindDismissal(dialog) {
      var closeButton = dialog.querySelector('[data-sg-cart-exit-close]');

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          dismissPopup(dialog);
        });
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          dismissPopup(dialog);
        }
      });

      dialog.addEventListener('cancel', function () {
        writeSession(dismissedKey, 'true');
        dialog.dataset.sgCartExitOpen = 'false';
      });

      dialog.addEventListener('close', function () {
        dialog.classList.remove('is-visible');
        dialog.dataset.sgCartExitOpen = 'false';
      });
    }

    function copyWithFallback(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '0';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      var didCopy = false;

      try {
        didCopy = document.execCommand('copy');
      } catch (error) {
        didCopy = false;
      }

      textarea.remove();
      return Promise.resolve(didCopy);
    }

    function copyDiscountCode(text) {
      if (window.navigator && window.navigator.clipboard && typeof window.navigator.clipboard.writeText === 'function') {
        return window.navigator.clipboard.writeText(text).then(function () {
          return true;
        }).catch(function () {
          return copyWithFallback(text);
        });
      }

      return copyWithFallback(text);
    }

    function bindCopyButton(dialog) {
      var copyButton = dialog.querySelector('[data-sg-cart-exit-copy]');
      var status = dialog.querySelector('[data-sg-cart-exit-copy-status]');
      var resetTimer = null;

      if (!copyButton) return;

      copyButton.addEventListener('click', function () {
        var discountCode = copyButton.dataset.discountCode || '';
        if (!discountCode) return;

        copyDiscountCode(discountCode).then(function (didCopy) {
          window.clearTimeout(resetTimer);

          if (didCopy) {
            copyButton.classList.add('is-copied');
            copyButton.setAttribute('aria-label', 'Discount code copied');
            if (status) status.textContent = 'Discount code copied';
          } else {
            copyButton.setAttribute('aria-label', 'Copy discount code failed');
            if (status) status.textContent = 'Copy failed';
          }

          resetTimer = window.setTimeout(function () {
            copyButton.classList.remove('is-copied');
            copyButton.setAttribute('aria-label', 'Copy discount code');
            if (status) status.textContent = '';
          }, 1800);
        });
      });
    }

    function bindCartActivity(dialog) {
      if (dialog.dataset.sgCartExitActivityReady === 'true') return;
      dialog.dataset.sgCartExitActivityReady = 'true';

      var markQuiet = function () {
        setCartQuietPeriod(dialog);
      };

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
          markQuiet();
        }
      }, true);

      document.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target.closest('button[name="add"], input[name="add"], [data-add-to-cart], [data-cart-add], [data-product-submit]') : null;
        if (target) {
          markQuiet();
        }
      }, true);

      [
        'ajaxProduct:added',
        'cart:change',
        'cart:refresh',
        'cart:updated',
        'cart:drawer:open',
        'product:added',
        'theme:cart:change'
      ].forEach(function (eventName) {
        document.addEventListener(eventName, markQuiet);
      });
    }

    function initCartExitIntent(dialog) {
      if (!dialog || dialog.dataset.sgCartExitReady === 'true') return;
      dialog.dataset.sgCartExitReady = 'true';

      if (isCheckoutPage() || hasSessionLock() || !window.fetch) return;

      bindDismissal(dialog);
      bindCopyButton(dialog);
      bindCartActivity(dialog);

      if (window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)').matches) {
        setupMobile(dialog);
      } else {
        setupDesktop(dialog);
      }
    }

    document.querySelectorAll('[data-sg-cart-exit-intent]').forEach(initCartExitIntent);

    document.addEventListener('shopify:section:load', function (event) {
      initCartExitIntent(event.target.querySelector('[data-sg-cart-exit-intent]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-collection-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBestSellers(section) {
      if (!section || section.dataset.sgBestSellersReady === 'true') return;
      section.dataset.sgBestSellersReady = 'true';

      if (!window.fetch || !window.DOMParser) return;

      var fetchUrl = section.dataset.sgBestSellersFetchUrl;
      var sectionId = section.dataset.sgBestSellersSectionId;
      var grid = section.querySelector('[data-sg-best-sellers-grid]');

      if (!fetchUrl || !sectionId || !grid) return;

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (sections) {
          if (!sections || !sections[sectionId]) return;

          var parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
          var nextGrid = parsed.querySelector('[data-sg-best-sellers-grid]');
          if (!nextGrid || !nextGrid.children.length) return;

          var nextItems = Array.prototype.slice.call(nextGrid.children);
          grid.replaceChildren();
          nextItems.forEach(function (item) {
            grid.appendChild(item);
          });
          section.dataset.sgBestSellersSort = 'created-descending';
        })
        .catch(function () {});
    }

    document.querySelectorAll('[data-sg-best-sellers-section]').forEach(initBestSellers);

    document.addEventListener('shopify:section:load', function (event) {
      initBestSellers(event.target.querySelector('[data-sg-best-sellers-section]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-customer-gallery-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var galleryFormLabels = {
      'first name': {
        field: 'first-name',
        label: 'First Name',
        placeholder: '',
        required: true
      },
      'name': {
        field: 'first-name',
        label: 'First Name',
        placeholder: '',
        required: true
      },
      'last name': {
        field: 'last-name',
        label: 'Last Name',
        placeholder: '',
        required: true
      },
      'email': {
        field: 'email',
        label: 'Email',
        placeholder: '',
        required: true
      },
      'team': {
        field: 'team',
        label: 'What Team Are You Repping?',
        placeholder: 'Buffalo Bills, Toronto Maple Leafs, Custom Business Logo, etc.'
      },
      'what team are you repping?': {
        field: 'team',
        label: 'What Team Are You Repping?',
        placeholder: 'Buffalo Bills, Toronto Maple Leafs, Custom Business Logo, etc.'
      },
      'product type': {
        field: 'product-type',
        label: 'Product Type',
        required: true
      },
      'image upload': {
        field: 'upload-photo',
        label: 'Upload Photo',
        required: true
      },
      'upload photo': {
        field: 'upload-photo',
        label: 'Upload Photo',
        required: true
      },
      'tell us about your setup': {
        field: 'setup',
        label: 'Tell Us About Your Setup',
        placeholder: 'Basement bar, fan cave, office, bedroom, sports room, business display, etc.'
      }
    };

    function cleanGalleryFormText(value) {
      return (value || '').replace(/\s+/g, ' ').trim();
    }

    function galleryFormLabelKey(value) {
      return cleanGalleryFormText(value).replace(/\s*\*$/, '').toLowerCase();
    }

    function setGalleryFormText(element, text) {
      if (!element || cleanGalleryFormText(element.textContent) === text) return;
      element.textContent = text;
    }

    function setGalleryFormAttribute(element, name, value) {
      if (!element || element.getAttribute(name) === value) return;
      element.setAttribute(name, value);
    }

    function removeGalleryFormAttribute(element, name) {
      if (!element || !element.hasAttribute(name)) return;
      element.removeAttribute(name);
    }

    function closestGalleryFormField(element) {
      if (!element || !element.closest) return null;

      return element.closest(
        '._formFieldContainer_1mxsl_5, ._selectContainer_12thd_6, ._formFileInput_ehvsf_1, ._checkboxFieldSet_1hja3_3, ._consentCheckboxContainer_cit2d_49'
      );
    }

    function markGalleryFormField(element, config) {
      var field = closestGalleryFormField(element);
      if (!field || !config) return;

      setGalleryFormAttribute(field, 'data-sg-gallery-field', config.field);

      if (config.required) {
        setGalleryFormAttribute(field, 'data-sg-gallery-required', 'true');
      } else {
        removeGalleryFormAttribute(field, 'data-sg-gallery-required');
      }

      if (config.optional) {
        var control = field.querySelector('input, textarea, select, button');
        var isRequired =
          control &&
          (control.required ||
            control.getAttribute('aria-required') === 'true' ||
            control.getAttribute('required') === 'true');

        setGalleryFormAttribute(field, 'data-sg-gallery-optional', isRequired ? 'false' : 'true');
      }

      if (typeof config.placeholder === 'string') {
        var input = field.querySelector('input:not([type="hidden"]), textarea');
        if (input && input.getAttribute('placeholder') !== config.placeholder) {
          input.setAttribute('placeholder', config.placeholder);
        }
      }
    }

    function polishGalleryFormRoot(root) {
      if (!root) return;

      root.querySelectorAll('label, legend, ._label_12thd_10, ._formFileInput_ehvsf_1 > p._textBody_2aowh_10').forEach(function (label) {
        var config = galleryFormLabels[galleryFormLabelKey(label.textContent)];
        if (!config) return;

        setGalleryFormText(label, config.label);
        markGalleryFormField(label, config);
      });

      root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (input) {
        var field = closestGalleryFormField(input);
        var config = field && galleryFormLabels[galleryFormLabelKey(field.textContent)];

        if (!config && input.placeholder) {
          config = galleryFormLabels[galleryFormLabelKey(input.placeholder)];
        }

        if (!config || typeof config.placeholder !== 'string') return;
        if (input.getAttribute('placeholder') !== config.placeholder) {
          input.setAttribute('placeholder', config.placeholder);
        }
      });

      root.querySelectorAll('button._formSubmitButton_cit2d_96').forEach(function (button) {
        setGalleryFormText(button, 'Submit My Setup');
      });

      root.querySelectorAll('._formFileInputButton_ehvsf_18').forEach(function (button) {
        setGalleryFormText(button, 'Choose Photos');
      });

      root.querySelectorAll('._selectToggleText_12thd_25').forEach(function (text) {
        var currentText = cleanGalleryFormText(text.textContent);
        if (currentText.indexOf('Select a product') === 0 && currentText !== 'Select a product') {
          setGalleryFormText(text, currentText.replace('Select a product', '').trim());
        } else if (currentText === 'Select' || currentText === 'Select an option' || currentText === '') {
          setGalleryFormText(text, 'Select a product');
        }
      });
    }

    function polishGalleryFormHost(host) {
      if (!host || !host.shadowRoot) return false;

      polishGalleryFormRoot(host.shadowRoot);

      if (host.dataset.sgGalleryFormPolished === 'true') return true;
      host.dataset.sgGalleryFormPolished = 'true';

      if (window.MutationObserver) {
        new MutationObserver(function () {
          polishGalleryFormRoot(host.shadowRoot);
        }).observe(host.shadowRoot, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      return true;
    }

    function initGallerySubmissionForms(section) {
      if (section.dataset.sgGalleryFormsReady === 'true') return;
      section.dataset.sgGalleryFormsReady = 'true';

      function run() {
        section.querySelectorAll('shopify-forms-embed').forEach(polishGalleryFormHost);
      }

      run();

      if (window.MutationObserver) {
        new MutationObserver(run).observe(section, {
          childList: true,
          subtree: true
        });
      }

      window.setTimeout(run, 400);
      window.setTimeout(run, 1200);
      window.setTimeout(run, 3000);
    }

    function initGallery(section) {
      if (section.dataset.sgGalleryFiltersReady === 'true') return;
      section.dataset.sgGalleryFiltersReady = 'true';

      var buttons = section.querySelectorAll('.sg-gallery-page__filter');
      var cards = section.querySelectorAll('.sg-gallery-page__card');
      if (!buttons.length || !cards.length) return;

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.dataset.filter || 'all';

          buttons.forEach(function (nextButton) {
            var isActive = nextButton === button;
            nextButton.classList.toggle('is-active', isActive);
            nextButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          cards.forEach(function (card) {
            var category = card.dataset.category || 'all';
            card.hidden = filter !== 'all' && category !== filter;
          });
        });
      });
    }

    function initGalleryPage(section) {
      initGallery(section);
      initGallerySubmissionForms(section);
    }

    document.querySelectorAll('[data-sg-gallery-page]').forEach(initGalleryPage);

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.matches && event.target.matches('[data-sg-gallery-page]')) {
        initGalleryPage(event.target);
      }

      event.target.querySelectorAll('[data-sg-gallery-page]').forEach(initGalleryPage);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
